import {bodyArea} from "../../../models/bodyArea";
import {NavLink, useNavigate} from "react-router-dom";
import React from "react";
import {useForm} from "react-hook-form";
import {ApiError, ApiService} from "../../../service/ApiService";
import {scrollTo} from "../../../service/ToolsService";
import {Require} from "../Require";

type FormDataType = {
  label: string,
}

type BodyAreaFormProp = {
  bodyArea?: bodyArea
}

export const BodyAreaForm = ({bodyArea}: BodyAreaFormProp) => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setError,
    formState: {errors}
  } = useForm<FormDataType>({
    defaultValues: {
      label: bodyArea?.label,
    }
  });

  const onSubmit = async (data: FormDataType) => {
    const apiData = {
      label: data.label,
    };

    try {
      bodyArea
        ? await ApiService.patch(`/body-area/${bodyArea.bodyAreaId}`, {param: () => apiData})
        : await ApiService.post('/body-area', {param: () => apiData});

      navigate('/admin/equipment/body-area');
      scrollTo();
    } catch (e: any) {
      const error: ApiError = e as ApiError;

      error.errors?.forEach((e: {
        field: string,
        message: string
      }) => {
        setError(e.field as "label", {
          type: "manual",
          message: e.message
        })
      });
    }
  }

  return (
    <>
      <form className="p-3" method="post" onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex flex-wrap">
          <div className="col min-w400px max-w600px pe-4">
            <div className="mb-3">
              <label className="form-label" htmlFor="form-name">Nom <Require/></label>
              <input id="form-name" type="text" className="form-control" placeholder="~" {...register('label', {
                required: 'Le nom est obligatoire',
                validate: {
                  minLength: (value) =>
                    (value ?? '').length <= 255 || 'Le nom ne doit pas dépasser 255 caractères',
                },
              })} />
              {errors.label && <p className="text-danger">{errors.label.message}</p>}
            </div>
          </div>
        </div>

        <div className="mt-3">
          <button className="btn btn-sm btn-success me-1" type="submit">Enregistrer</button>
          <NavLink to={`/admin/equipment/body-area`} onClick={scrollTo} className="btn btn-sm btn-info">Retour aux zones</NavLink>
        </div>
      </form>
    </>
  )
}
